// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__mgGZM","footer":"ChangeClinic_footer__2x6Be"};